import { render, staticRenderFns } from "./electric-bill-info.vue?vue&type=template&id=3112a416&scoped=true&"
import script from "./electric-bill-info.vue?vue&type=script&lang=js&"
export * from "./electric-bill-info.vue?vue&type=script&lang=js&"
import style0 from "./electric-bill-info.vue?vue&type=style&index=0&id=3112a416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112a416",
  null
  
)

export default component.exports